<template>
  <div class="target-row wrap" :id="'subrule' + tblProfGroupSubRuleID" v-if="hideFullSubrule">
    <div class="subtarget-primaryheader" v-if="subruleHeader">
      <span v-html="subruleHeader"></span>
    </div>
    <div
      v-if="hidesubrule"
      class="subtarget-item subtarget-item1 pointer"
      :class="subheaderactive"
      :style="{ width: widthsubtargetitem1 }"
      @click.prevent="subruleToggle()"
    >
      <div class="subheader-content">
        <font-awesome-icon icon="chevron-down" v-if="!this.subruleloaded.visible" />
        <font-awesome-icon icon="chevron-up" v-if="this.subruleloaded.visible" />
        <span v-html="subruleName"></span>
      </div>
    </div>
    <!-- progressdot -->
    <div
      v-if="
        hidesubrule &&
          subruleTrafficLightColor !== null &&
          (tblProfGroupSubruleCodeShowSubruleOverviewCols === 1 ||
            tblProfGroupSubruleCodeShowSubruleOverviewCols === 2 ||
            tblProfGroupSubruleCodeShowSubruleOverviewCols === 6)
      "
      class="subtarget-item target-item-progresscircle pointer"
      :class="subsubheaderactive"
      :style="{ width: widthprogresscircle }"
      @click.prevent="subruleToggle(tblProfGroupSubRuleID)"
    >
      <div
        class="circle"
        :class="'circle_' + subruleTrafficLightColor"
        :title="lblSubruleStatus !== '' || lblSubruleStatus !== null ? lblSubruleStatus : ''"
      >
        <font-awesome-icon icon="circle" class="fa-lg progresscircle" :style="{ color: subruleTrafficLightColor }" />
      </div>
    </div>
    <div
      v-if="
        hidesubrule &&
          lblSubruleMin > 0 &&
          subruleTrafficLightColor === null &&
          (tblProfGroupSubruleCodeShowSubruleOverviewCols === 1 ||
            tblProfGroupSubruleCodeShowSubruleOverviewCols === 2 ||
            tblProfGroupSubruleCodeShowSubruleOverviewCols === 6)
      "
      class="subtarget-item target-item-emptyprogresscircle pointer"
      :class="subsubheaderactive"
      :style="{ width: widthprogresscircle }"
      @click.prevent="subruleToggle(tblProfGroupSubRuleID)"
    ></div>
    <!-- nvt -->
    <div
      v-if="
        hidesubrule &&
          (tblProfGroupSubruleCodeShowSubruleOverviewCols === 1 ||
            tblProfGroupSubruleCodeShowSubruleOverviewCols === 3 ||
            tblProfGroupSubruleCodeShowSubruleOverviewCols === 5 ||
            tblProfGroupSubruleCodeShowSubruleOverviewCols === 6) &&
          lblSubruleMin <= 0
      "
      class="subtarget-item target-item-nvt pointer"
      :class="subsubheaderactive"
      :style="{ width: widthprogresscircle }"
      @click.prevent="subruleToggle(tblProfGroupSubRuleID)"
    >
      <!-- NVT: subruleoverviewcols === 1 of 3 && lblSubruleMin <= 0 -->
      <!-- als overviewcols 1 of 3 is, en subruleminimum is kleiner of gelijk aan null -->
      <span class="progressnvt" v-html="translation(13791)"></span>
    </div>
    <!-- punten -->
    <div
      v-if="hidesubrule && tblProfGroupSubruleCodeShowSubruleOverviewCols === 7"
      class="subtarget-item target-item-score pointer"
      :class="subsubheaderactive"
      :style="{ width: '20%' }"
      @click.prevent="subruleToggle(tblProfGroupSubRuleID)"
    >
      <div class="subheader-content subheader-score">
        <span>{{ translation(16584) }}</span
        ><span class="progressScore" v-html="lblSubruleScoreNetto"></span><span>{{ translation(16585) }}</span>
      </div>
    </div>
    <!-- progressbar -->
    <div
      v-if="
        hidesubrule &&
          (tblProfGroupSubruleCodeShowSubruleOverviewCols === 1 ||
            tblProfGroupSubruleCodeShowSubruleOverviewCols === 3 ||
            tblProfGroupSubruleCodeShowSubruleOverviewCols === 2 ||
            tblProfGroupSubruleCodeShowSubruleOverviewCols === 5 ||
            tblProfGroupSubruleCodeShowSubruleOverviewCols === 6) &&
          trafficlightplacement === true
      "
      class="subtarget-item target-item-progressbar pointer"
      :class="subsubheaderactive"
      :style="{ width: widthprogressbar }"
      @click.prevent="subruleToggle(tblProfGroupSubRuleID)"
    >
      <XVprogressbar
        v-if="
          (tblProfGroupSubruleCodeShowSubruleOverviewCols === 1 ||
            tblProfGroupSubruleCodeShowSubruleOverviewCols === 3) &&
            lblSubruleMin > 0
        "
        v-bind="{
          nettoTarget: 100,
          normTarget: 100,
          progressTarget: subruleProgress,
          targetCalcResult: '0',
          statustextTarget: '',
          settingprogbar: 7
        }"
      ></XVprogressbar>

      <XVprogressbar
        v-if="
          (tblProfGroupSubruleCodeShowSubruleOverviewCols === 5 ||
            tblProfGroupSubruleCodeShowSubruleOverviewCols === 6) &&
            lblSubruleMin > 0
        "
        v-bind="{
          nettoTarget: lblSubruleScoreNetto,
          normTarget: lblSubruleMin,
          progressTarget: subruleProgress,
          targetCalcResult: '0',
          statustextTarget: '',
          settingprogbar: 8
        }"
      ></XVprogressbar>
    </div>
    <!-- subregel visible -->
    <div class="subtarget-item targetbox" v-if="hidesubrule && subruleloaded.visible">
      <div class="row subruleDesc" v-if="subruleDesc">
        <div class="col-md-12 form-group">
          <span v-html="subruleDesc"></span>
        </div>
      </div>
      <XVbootstraprow :label="translation(2267)" v-if="lblSubruleStatus_Visible === 1">
        <span v-html="lblSubruleStatus"></span>
      </XVbootstraprow>
      <XVbootstraprow :label="translation(210)" v-if="lblSubruleMin_Visible === 1">{{
        lblSubruleMin | format2decimal
      }}</XVbootstraprow>
      <XVbootstraprow
        :label="translation(3663)"
        :helptext="translation(3665)"
        v-if="lblSubruleScore_Visible === 1 && tblProfGroupSubRuleIndicationExemption === 1"
        >{{ lblSubruleScore | format2decimal }}</XVbootstraprow
      >
      <XVbootstraprow
        :label="translation(204)"
        :helptext="translation(1422)"
        v-if="lblSubruleScore_Visible === 1 && tblProfGroupSubRuleIndicationExemption !== 1"
        >{{ lblSubruleScore | format2decimal }}</XVbootstraprow
      >
      <XVbootstraprow
        :label="translation(3908)"
        :helptext="translation(3909)"
        v-if="lblSubruleValidatedPoints_Visible === 1"
        >{{ lblSubruleValidatedPoints | format2decimal }}</XVbootstraprow
      >
      <XVbootstraprow :label="translation(15381)" v-if="lblSubruleMax_Visible === 1">
        {{ lblSubruleMax | format2decimal }}
      </XVbootstraprow>
      <div class="subrulebuttonrow" v-for="(button, index) in subrulebuttons" :key="index">
        <button
          v-if="button && button.addActivityType !== 4"
          :id="button.tblProfGroupAddActivityRowID"
          type="button"
          class="btn btn-primary btn-xs subrulebuttons margin10bottom"
          @click="subrulebuttonclick(button.addActivityUrl)"
          @mouseenter="helphover(button.addActivityInstruction)"
        >
          <font-awesome-icon :icon="['fas', 'plus']" />
          {{ button.addActivityName }}
        </button>
        <span v-if="button && button.addActivityType === 4" class="targetaddActivityName">
          {{ button.addActivityName }}
        </span>
      </div>
      <div class="row rowNoActs" v-if="codeHideGridActs === 0 && filterfunc(targetTable.tabledata).length === 0">
        <div class="col-md-12">
          <span>{{ translation(10561) }}</span>
        </div>
      </div>
      <div class="subruletable row" v-if="codeHideGridActs === 0 && filterfunc(targetTable.tabledata).length !== 0">
        <div class="col-md-12">
          <XVtable
            :id="tblProfGroupSubRuleID"
            :tablesetting="targetTable.tablesetting"
            :tabledata="targetTable.tabledata"
            :rowvisible="targetTable.rowvisible"
            :tablecolumnsetting="targetTableColumns(tblProfGroupSubRuleID)"
            v-on:sortXVTable="XVTablesort"
            :XVtableSetRowStateProperty="XVtableSetRowStateProperty"
            :filterfunc="filterfunc"
            :chevronhiddenDesktop="true"
            :paging="false"
          >
            <template slot="tblPersonActivityDateCompleted" slot-scope="dr">
              <span v-if="dr.row.tblPersonActivityDateCompleted">
                <a :href="'/' + dr.row.actLink">{{ dr.celldata }}</a>
              </span>
              <span v-if="dr.row.addActLink">
                <a :href="dr.row.addActLink" v-if="dr.row.addActLink.includes('public')" target="_blank">
                  {{ dr.row.addActTxt }}
                </a>
                <a :href="dr.row.addActLink" v-else>{{ dr.row.addActTxt }}</a>
              </span>
            </template>
            <template slot="tblPersonPEActivityPEPoints" slot-scope="dr">
              <span
                class="spe026ActivityPEPoints"
                v-if="dr.row.tblPersonPEActivityPEPoints && isNaN(dr.row.tblPersonPEActivityPEPoints)"
                >{{ Number(dr.row.tblPersonPEActivityPEPoints) | format2decimal }}</span
              >
              <span
                class="spe026ActivityPEPoints"
                v-if="dr.row.tblPersonPEActivityPEPoints && !isNaN(dr.row.tblPersonPEActivityPEPoints)"
                >{{ Number(dr.row.tblPersonPEActivityPEPoints) | format2decimal }}</span
              >
            </template>
            <template slot="statusTxt" slot-scope="dr">
              <span v-if="dr.row.statusLink">
                <a :href="'/' + dr.row.statusLink" v-html="dr.row.statusTxt"></a>
              </span>
              <span v-if="!dr.row.statusLink" v-html="dr.row.statusTxt"></span>
            </template>
            <template slot="statusTxt_detailrow" slot-scope="dr">
              <div class="row">
                <div class="col-md-4 col-sm-4 col-xs-12">
                  <label>{{ translation(2267) }}</label
                  >&nbsp;<XVhelpcontrol :helptext="translation(3322)"></XVhelpcontrol>
                </div>
                <div class="col-md-8 col-sm-8 col-xs-12 form-group">
                  <span v-if="dr.row.statusLink">
                    <a :href="'/' + dr.row.statusLink" v-html="dr.row.statusTxt"></a>
                  </span>
                  <span v-if="!dr.row.statusLink" v-html="dr.row.statusTxt"></span>
                </div>
              </div>
            </template>
            <template slot="tblPersonPEActivityPEPoints_detailrow" slot-scope="dr">
              <div class="row">
                <div class="col-md-4 col-sm-4 col-xs-12">
                  <label>{{ translation(96) }}</label
                  >&nbsp;<XVhelpcontrol :helptext="translation(3321)"></XVhelpcontrol>
                </div>
                <div class="col-md-8 col-sm-8 col-xs-12 form-group">
                  <span>{{ Number(dr.row.tblPersonPEActivityPEPoints) | format2decimal }}</span>
                </div>
              </div>
            </template>
          </XVtable>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FAMixin } from 'pevueglobal'
import { mapMutations } from 'vuex'
export default {
  mixins: [FAMixin],
  name: 'XVtargetsubregels',
  props: [
    'tblProfGroupSubRuleID',
    'tblProfGroupSubRuleIndicationExemption',
    'tblProfGroupSubruleCodeShowSubruleOverviewCols',
    'codeHideGridActs',
    'lblSubruleMax',
    'lblSubruleMax_Visible',
    'lblSubruleMin',
    'lblSubruleMin_Visible',
    'lblSubruleScore',
    'lblSubruleScoreNetto',
    'lblSubruleScore_Visible',
    'lblSubruleStatus',
    'lblSubruleStatus_Visible',
    'lblSubruleValidatedPoints',
    'lblSubruleValidatedPoints_Visible',
    'subruleDesc',
    'subruleHeader',
    'subruleName',
    'subruleProgress',
    'subruleTrafficLightColor',
    'subrulebuttons',
    'subruleloaded',
    'XVTablesort',
    'XVtableSetRowStateProperty',
    'XVtablecolumnsettingchanged', // getters
    'targetTable',
    'targetTableColumns', // mutations
    'getXVtable', // action
    'setsession', // mutations
    'trafficlightplacement',
    'codeHideWhenZeroPoints'
  ],
  data: function() {
    return {}
  },
  mounted() {},
  computed: {
    hideFullSubrule() {
      if (this.lblSubruleMin <= 0 && this.codeHideWhenZeroPoints === 2) {
        return false
      } else {
        return true
      }
    },
    hidesubrule() {
      if (this.codeHideWhenZeroPoints === 0) {
        return true
      } else if (this.lblSubruleMin <= 0 && this.codeHideWhenZeroPoints === 1) {
        return false
      } else if (this.lblSubruleMin <= 0 && this.codeHideWhenZeroPoints === 2) {
        return false
      } else {
        return true
      }
    },
    widthsubtargetitem1() {
      if (
        this.tblProfGroupSubruleCodeShowSubruleOverviewCols === 1 ||
        this.tblProfGroupSubruleCodeShowSubruleOverviewCols === 6
      ) {
        if (this.wSM === true || this.wXS === true) {
          return '100%'
        } else {
          return '65%'
        }
      } else if (this.tblProfGroupSubruleCodeShowSubruleOverviewCols === 2 && this.trafficlightplacement === false) {
        if (this.wSM === true || this.wXS === true) {
          return '100%'
        } else {
          if (
            this.lblSubruleMin <= 0 &&
            this.subruleTrafficLightColor === null &&
            this.tblProfGroupSubruleCodeShowSubruleOverviewCols === 2
          ) {
            return '100%'
          }
          return '90%'
        }
      } else if (
        this.tblProfGroupSubruleCodeShowSubruleOverviewCols === 3 ||
        this.tblProfGroupSubruleCodeShowSubruleOverviewCols === 5
      ) {
        if (this.wSM === true || this.wXS === true) {
          return '100%'
        } else {
          return '75%'
        }
      } else if (this.tblProfGroupSubruleCodeShowSubruleOverviewCols === 2 && this.trafficlightplacement === true) {
        if (this.wSM === true || this.wXS === true) {
          return '100%'
        } else {
          return '65%'
        }
      } else if (this.tblProfGroupSubruleCodeShowSubruleOverviewCols === 7) {
        if (this.wSM === true || this.wXS === true) {
          return '100%'
        } else {
          return '80%'
        }
      } else {
        return '100%'
      }
    },
    widthprogressbar() {
      if (
        this.tblProfGroupSubruleCodeShowSubruleOverviewCols === 1 ||
        this.tblProfGroupSubruleCodeShowSubruleOverviewCols === 6
      ) {
        if (this.wSM === true || this.wXS === true) {
          return '90%'
        } else {
          return '25%'
        }
      } else if (this.tblProfGroupSubruleCodeShowSubruleOverviewCols === 2 && this.trafficlightplacement === false) {
        return '0%'
      } else if (this.tblProfGroupSubruleCodeShowSubruleOverviewCols === 2 && this.trafficlightplacement === true) {
        if (this.wSM === true || this.wXS === true) {
          return '0%'
        } else {
          return '25%'
        }
      } else if (
        this.tblProfGroupSubruleCodeShowSubruleOverviewCols === 3 ||
        this.tblProfGroupSubruleCodeShowSubruleOverviewCols === 5
      ) {
        if (this.wSM === true || this.wXS === true) {
          return '90%'
        } else {
          return '25%'
        }
      } else {
        return '0%'
      }
    },
    widthprogresscircle() {
      if (
        this.tblProfGroupSubruleCodeShowSubruleOverviewCols === 1 ||
        this.tblProfGroupSubruleCodeShowSubruleOverviewCols === 2 ||
        this.tblProfGroupSubruleCodeShowSubruleOverviewCols === 6
      ) {
        return '10%'
      } else if (
        this.tblProfGroupSubruleCodeShowSubruleOverviewCols === 3 ||
        this.tblProfGroupSubruleCodeShowSubruleOverviewCols === 5
      ) {
        if (this.wSM === true || this.wXS === true) {
          return '10%'
        } else {
          return '0%'
        }
      } else {
        return '0%'
      }
    },
    subheaderactive() {
      if (this.subruleloaded.visible === true) {
        return 'subheaderactive'
      } else {
        return ''
      }
    },
    subsubheaderactive() {
      if (this.subruleloaded.visible === true) {
        return 'subsubheaderactive'
      } else {
        return ''
      }
    }
  },
  methods: {
    ...mapMutations(['addNotification']),
    subruleToggle() {
      this.subruleloaded.visible = !this.subruleloaded.visible
      this.getXVtable(this.tblProfGroupSubRuleID)
      this.setsession(this.tblProfGroupSubRuleID)
    },
    subrulebuttonclick(url) {
      window.location = url
    },
    helphover(text) {
      if (text !== '') this.addNotification({ message: text, groupname: 'info' })
    },
    filterfunc: function(tabledata) {
      return tabledata.filter(d => d.tblProfgroupSubruleID === this.tblProfGroupSubRuleID)
    }
  }
}
</script>

<style>
.flex-container {
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-flex-wrap: nowrap;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
  -webkit-justify-content: flex-start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-align-content: stretch;
  -ms-flex-line-pack: stretch;
  align-content: stretch;
}
.target-row {
  padding: 0;
  margin: 0;
  border: 0;
  -webkit-order: 0;
  -ms-flex-order: 0;
  order: 0;
  -webkit-flex: 1 1 auto;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  -webkit-align-self: auto;
  -ms-flex-item-align: auto;
  align-self: auto;
}
.wrap {
  -webkit-flex-wrap: wrap;
  flex-wrap: wrap;
}
.subtarget-primaryheader,
.subtarget-item {
  width: 100%;
  font-weight: normal;
  text-align: left;
}
.subtarget-primaryheader {
  padding: 10px 10px 10px 10px;
}
.subtarget-item {
  color: currentColor;
}
.subtarget-item1 {
  display: flex;
}
.target-item-progressbar {
  padding-left: 0;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-right: 20px;
}
.target-item-progresscircle {
  text-align: right;
  display: flex;
}
.circle {
  align-self: flex-start;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: auto;
  padding-right: 6px;
}
.subheader-content {
  align-self: flex-start;
  margin-top: auto;
  margin-bottom: auto;
  padding: 14px 6px 14px 14px;
}
.subheader-score {
  text-align: center;
}
.target-item-emptyprogresscircle {
  flex: 0 1 auto;
}
.target-item-nvt {
  padding: 11px 6px 11px 14px;
  text-align: right;
  flex: 0 1 auto;
}
.progressnvt {
  vertical-align: -webkit-baseline-middle;
  vertical-align: -moz-middle-with-baseline;
}
.targetbox {
  width: 100%;
  padding: 6px 6px 6px 14px;
  border-bottom: 1px solid #efefef !important;
}
.XVdatagriditem {
  background-color: #fff;
}
.subtarget-mainheader {
  font-weight: 700;
}
.targetaddActivityName,
.rowNoActs {
  color: #b7b7b7;
}
.subheaderactive,
.subsubheaderactive {
  background-color: #efefef;
}
.spe026ActivityPEPoints {
  margin: auto;
  display: table;
}
@media (max-width: 768px) {
  .target-item-progresscircle,
  .target-item-nvt,
  .targetbox {
    border-left-width: 3px;
    border-left-style: solid;
    padding: 10px 10px 10px 10px;
  }
  .target-item-progressbar {
    padding: 2px 10px 0px 10px;
  }
  .subtarget-item1 {
    background-color: #ededed;
    padding: 0;
    font-weight: 700;
  }
  .subsubheaderactive {
    background-color: #fff;
  }
}
.XVdatagridheader .XVhelpcontrol,
.XVdetailRow .XVhelpcontrol {
  vertical-align: text-top;
}
</style>
